<template>
  <div class="cadfm-container-vertical">
    <slot></slot>
  </div>
</template>
<script>


//import DataTableComponentSimple from "@/components/shared/DataTableComponentSimple"
//import EmptyComponent from "@/components/shared/EmptyComponent"
export default {
  name: "ActionPanel"
}
</script>

<style scooped>

</style>



// WEBPACK FOOTER //
// src/components/shared/ActionPanel.vue